import styled from 'styled-components'

import InfoTooltip from '@/app/components/InfoToolTip'
import { IColumn } from '@/app/components/Table/types'
import { colors, spaces } from '@/config/global-parameters'
import { millionFormatter, percentFormatter } from '@/helpers/formatters'

import ParticipationItem from './ParticipationItem'

const BoldText = styled.div`
  font-weight: 700;
`

const PopoverText = styled.div`
  font-weight: 700;
  text-align: center;
`

const feePopoverText = (
  <div>
    <PopoverText>Valor Multa</PopoverText>
    <div>$31.537 - $189.222</div>
  </div>
)

const tableColumns: IColumn[] = [
  {
    align: 'flex-start',
    canSort: false,
    dataIndex: 'election',
    key: 'eleccion',
    render: ({ election }) => election,
    title: 'ELECCIÓN',
    width: '1.8fr',
  },
  {
    align: 'center',
    canSort: false,
    dataIndex: 'votan',
    key: 'votan',
    render: ({ participation, total }) => (
      <BoldText>{percentFormatter.format(Number(participation / total) || 0)}</BoldText>
    ),
    title: 'VOTAN',
    width: '1fr',
  },
  {
    align: 'center',
    canSort: false,
    dataIndex: 'participation',
    key: 'participation',
    render: ({ participation, total }) => (
      <ParticipationItem
        padron={total}
        participation={participation}
        shortLabel="part"
      />
    ),
    width: '2.3fr',
  },
  {
    align: 'center',
    canSort: false,
    dataIndex: 'no_votan',
    key: 'no_votan',
    render: ({ currentVotation, participation, total }) => (
      <NoVoteWrapper>
        <BoldText>{percentFormatter.format(Number((total - participation) / total) || 0)}</BoldText>
        {currentVotation && (
          <InfoTooltip
            color={colors.colorBlack}
            id="multa-tooltip"
            message={feePopoverText}
          />
        )}
      </NoVoteWrapper>
    ),
    title: 'NO VOTAN',
    width: '1fr',
  },
  {
    align: 'center',
    canSort: false,
    dataIndex: 'total',
    key: 'total',
    render: ({ total }) => millionFormatter.format(Number(total) || 0),
    title: 'INSCRITOS',
    width: '1fr',
  },
  {
    align: 'center',
    canSort: false,
    dataIndex: 'type',
    key: 'votacion',
    title: 'VOTACIÓN',
    width: '1fr',
  },
]

const NoVoteWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: ${spaces.xs};
  align-items: center;
`

export default tableColumns
